import { render, staticRenderFns } from "./Marketing_impresos.vue?vue&type=template&id=6d63fa75&"
import script from "./Marketing_impresos.vue?vue&type=script&lang=js&"
export * from "./Marketing_impresos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports